import React, { Component } from "react";
import BrandGroup from "../../components/onboarding/BrandGroup";
import brandData from "../../data/onboarding-brands";

import { MultComponentButton } from "./OnboardingStyles";
import { answerBubbleStyle, answerBubbleStyleMobile } from "../../utils/styles";
import * as util from "../../utils/util";

import "./BrandsYouLike.css";

class BrandsYouLike extends Component {
  constructor(props) {
    super(props);

    this.handleDone = this.handleDone.bind(this);
    this.addItem = this.addItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.fun_notSure = this.fun_notSure.bind(this);
    this.handleAllSelect = this.handleAllSelect.bind(this);

    this.brandsStr = "";

    this.state = {
      brands: [],
      brandIndices: [],
      selected: null,
      finished: false,
      showText: this.props.showText,
    };
  }

  componentDidMount(){
    

    let doneButton = document.querySelector(".brands-you-like-button");
    if ( doneButton)doneButton.scrollIntoView();

     // 进度条
     try {
      if(this.props.fun_updateStage){
        var stage = this.props.stage;
        var stageSum = this.props.stageSum;
        if(stage && stageSum)
        this.props.fun_updateStage(parseInt(stage)-1,stageSum);
      }
    } catch (error) {
      console.error(error);
    }
    
  }

  componentDidUpdate() {
    // let doneButton = document.querySelector(".brands-you-like-button");
    // if (
    //   doneButton &&
    //   this.state.brandIndices.length === 1
    //   // &&
    //   // !util.isMobile(navigator.userAgent)
    // )
    //   doneButton.scrollIntoView();
  }

  handleAllSelect(){

    let brandIndices = [], brands= [];

    brandData.forEach((element,index) => {
      brandIndices.push(index+1);
      brands.push(element.title);
    });
    this.setState({ brandIndices: brandIndices,brands: brands });
  }

  fun_notSure(){
    this.setState({ 
      brands: ['not sure'],
      brandIndices:[10]
    },()=>{
      this.handleDone();
    });
  }

  addItem(answer) {
    let brands = this.state.brands;
    let brandIndices = this.state.brandIndices;

    if (answer.index === 7 || answer.index === 8) {
      //Remove other items if selecting "I don’t have a preference"
      brands.splice(0, brands.length);
      brandIndices.splice(0, brandIndices.length);
    } else {
      //Remove "I don’t have a preference" if seleting other items
      if (
        brands.indexOf("I don’t have a preference") > -1 &&
        brandIndices.indexOf(7) > -1
      ) {
        brands.splice(brands.indexOf("I don’t have a preference"), 1);
        brandIndices.splice(brandIndices.indexOf(7), 1);
      }
    }

    let index = brands.indexOf(answer.value);
    if (index === -1) {
      brands.push(answer.value);
      this.setState({ brands: brands });
    }

    index = brandIndices.indexOf(answer.index);
    if (index === -1) {
      brandIndices.push(answer.index);
      this.setState({ brandIndices: brandIndices });
    }
  }

  removeItem(answer) {
    let brands = this.state.brands;
    let brandIndices = this.state.brandIndices;

    let index = brands.indexOf(answer.value);
    if (index > -1) {
      brands.splice(index, 1);
      this.setState({ brands: brands });
    }
    index = brandIndices.indexOf(answer.index);
    if (index > -1) {
      brandIndices.splice(index, 1);
      this.setState({ brandIndices: brandIndices });
    }
  }

  handleDone() {
    if (this.state.brands.length > 0 && this.state.brandIndices.length > 0) {
      this.setState({ finished: true });
      this.brandsStr = this.state.brands.join(", ");
      localStorage.setItem("SQ_brand",this.state.brandIndices.join(", "));
      
      try {
        let step = this.props.step;
        localStorage.setItem("doneQuizStepId",step.id);
      } catch (error) {
        console.error(error);
      }

      try {
        if(this.props.fun_updateStage){
          var stage = this.props.stage;
          var stageSum = this.props.stageSum;
          if(stage && stageSum)
          this.props.fun_updateStage(stage,stageSum);
        }
      } catch (error) {
        console.error(error);
      }

      this.props.step.value = {value: this.state.brandIndices.join(", "), label: this.state.brands.join(", ") };

      this.props.triggerNextStep({ value: {value: this.state.brandIndices.join(", "), label: this.state.brands.join(", ") }  });
    }else{
      alert("Please select an answer.");
    }
  }

  renderBlocks() {
    let brandBlockRender = brandData.map((block, index) => {
      const indexHolder = index + 1;
      const imageRender = block.images.map((img, ind) => {
        const src =
          "/images/onboarding/brands/" +
          indexHolder.toString() +
          "/" +
          img +
          ".png";
        return (
          <div
            key={ind}
            className={"image-block " + ind}
            // className={
            //   ind == 4 && block.images.length < 6
            //     ? "postionLeft image-block " + ind
            //     : "image-block " + ind
            // }
          >
            <img alt={img} src={src} />
          </div>
        );
      });
      return (
        <BrandGroup
          key={index}
          block={block}
          index={index + 1}
          imageRender={imageRender}
          noPref={false}
          addItem={this.addItem}
          removeItem={this.removeItem}
          brandIndices={this.state.brandIndices}
        />
      );
    });

    brandBlockRender.push(
      <BrandGroup
        key={7}
        block={{ title: "I don’t have a preference", images: [] }}
        index={7}
        noPref={true}
        addItem={this.addItem}
        removeItem={this.removeItem}
        brandIndices={this.state.brandIndices}
      />
    );

    // brandBlockRender.push(
    //   <a class="link-sk link-ns-po" onClick={this.fun_notSure} brandIndices={this.state.brandIndices}  removeItem={this.removeItem} addItem={this.addItem} index={8}>not sure</a>
    // );

    return brandBlockRender;
  }

  renderProducts() {
    return (
      <div className="onb-item-container brands-you-like-button">
          <div className="onb-text-conten">{this.state.showText}</div>
          <div className="onb-se-allBut" style={{marginTop:'13px'}}>Select all that apply</div>
          <div className="container brands-you-like">{this.renderBlocks()}</div>
      </div>          
      
    );
  }

  render() {
    if (this.state.finished) {
      return (
        <div className="onb-item-container">
            <div className="onb-text-conten">{this.state.showText}</div>
        </div>
      );
    } else {
      return (

        <div style={{ margin: "1px auto" }}>
          {this.renderProducts()}
          <button className="p-a-n-button submit-but" onClick={this.handleDone}>Continue</button>

        </div>
      );
    }
  }
}

export default BrandsYouLike;



// WEBPACK FOOTER //
// ./src/views/onboarding/BrandsYouLike.js